import {
  REQUEST_ADD_ELIGIBILITY_TRANSACTION,
  REQUEST_ADD_TRANSACTION,
  REQUEST_GET_TRANSACTION,
  REQUEST_SET_TRANSACTION,
  REQUEST_UPDATE_TRANSACTION,
  REQUEST_UPDATE_ELIGIBILITY_TRANSACTION,
  REQUEST_ADD_CONTACT_TRANSACTION,
  REQUEST_GET_CONTACT_TRANSACTION,
  REQUEST_SET_CONTACT_TRANSACTION,
  RESET_STORE_TRANSACTION,
  REQUEST_UPDATE_CONTACT_TRANSACTION,
  REQUEST_GET_MISSION_TRANSACTION,
  REQUEST_SET_MISSION_TRANSACTION,
  REQUEST_GET_MISSION_VICTIM_EXPERTISE,
  REQUEST_SET_MISSION_VICTIM_EXPERTISE,
  REQUEST_UPDATE_MISSION_TRANSACTION,
  REQUEST_GET_FEE_NOTES_TRANSACTION,
  REQUEST_IMPORT_MISSION_EXPERTISE,
  REQUEST_GET_JUDICIARY_EXPERT_REPORT,
  REQUEST_SET_JUDICIARY_EXPERT_REPORT,
  REQUEST_MAKE_DECISION_VICTIM_INFO,
  REQUEST_REJECT_TRANSACTION,
  REQUEST_ADD_QUOTATION_DOCUMENT,
  REQUEST_GET_TRANSACTION_INBOXE_AREA,
  REQUEST_SET_TRANSACTION_INBOXE_AREA,
  REQUEST_ADD_TUTOR_INFO,
  REQUEST_ADD_BENEFICIARY,
} from 'containers/TransactionManagerTimeLine/constants';
import { BeneficiaryType } from 'typings/globalTypes';

export const requestAddEligibilityTransaction = (
  payload: any,
  successCallback: Function,
) => ({
  type: REQUEST_ADD_ELIGIBILITY_TRANSACTION,
  payload,
  successCallback,
});

export const requestUpdateEligibilityTransaction = (
  payload: any,
  successCallback: Function,
) => ({
  type: REQUEST_UPDATE_ELIGIBILITY_TRANSACTION,
  payload,
  successCallback,
});

export const requestAddTransaction = (
  payload: any,
  successCallback: Function,
) => ({
  type: REQUEST_ADD_TRANSACTION,
  payload,
  successCallback,
});

export const requestGetTransaction = (payload: any) => ({
  type: REQUEST_GET_TRANSACTION,
  payload,
});

export const requestSetTransaction = (payload: any) => ({
  type: REQUEST_SET_TRANSACTION,
  payload,
});

export const requestUpdateTransaction = (
  payload: any,
  successCallback: Function,
) => ({
  type: REQUEST_UPDATE_TRANSACTION,
  payload,
  successCallback,
});

export const requestAddContactTransaction = (
  payload: any,
  successCallback: Function,
) => ({
  type: REQUEST_ADD_CONTACT_TRANSACTION,
  payload,
  successCallback,
});

export const requestGetContactTransaction = (payload: any) => ({
  type: REQUEST_GET_CONTACT_TRANSACTION,
  payload,
});

export const requestSetContactTransaction = (payload: any) => ({
  type: REQUEST_SET_CONTACT_TRANSACTION,
  payload,
});

export const resetStoreTransaction = () => ({
  type: RESET_STORE_TRANSACTION,
});

export const requestUpdateContactTransaction = (
  payload: any,
  successCallback: Function,
) => ({
  type: REQUEST_UPDATE_CONTACT_TRANSACTION,
  payload,
  successCallback,
});

export const requestGetMissionTransaction = (payload: any) => ({
  type: REQUEST_GET_MISSION_TRANSACTION,
  payload,
});

export const requestSetMissionTransaction = (payload: any) => ({
  type: REQUEST_SET_MISSION_TRANSACTION,
  payload,
});

export const requestGetMissionVictimExpertise = (payload: any) => ({
  type: REQUEST_GET_MISSION_VICTIM_EXPERTISE,
  payload,
});

export const requestSetMissionVictimExpertise = (payload: any) => ({
  type: REQUEST_SET_MISSION_VICTIM_EXPERTISE,
  payload,
});
export const requestUpdateMissionTransaction = (
  payload: any,
  successCallback: Function,
) => ({
  type: REQUEST_UPDATE_MISSION_TRANSACTION,
  payload,
  successCallback,
});
export const requestGetFeeNotesTransaction = (payload: any) => ({
  type: REQUEST_GET_FEE_NOTES_TRANSACTION,
  payload,
});

export const requestImportMissionExpertise = (
  payload: any,
  successCallback: Function,
) => ({
  type: REQUEST_IMPORT_MISSION_EXPERTISE,
  payload,
  successCallback,
});

export const requestGetJudiciaryExpertReport = (payload: any) => ({
  type: REQUEST_GET_JUDICIARY_EXPERT_REPORT,
  payload,
});

export const requestSetJudiciaryExpertReport = (payload: any) => ({
  type: REQUEST_SET_JUDICIARY_EXPERT_REPORT,
  payload,
});

export const requestMakeDecisionVictimInfo = (
  payload: any,
  successCallBack: Function,
) => ({
  type: REQUEST_MAKE_DECISION_VICTIM_INFO,
  payload,
  successCallBack,
});

export const requestRejectTransaction = (
  payload: any,
  successCallBack: Function,
) => ({
  type: REQUEST_REJECT_TRANSACTION,
  payload,
  successCallBack,
});

export const requestAddQuotationDocument = (
  payload: any,
  successCallBack: Function,
) => ({
  type: REQUEST_ADD_QUOTATION_DOCUMENT,
  payload,
  successCallBack,
});

export const requestGetTransactionInboxeArea = (claimId: string) => ({
  type: REQUEST_GET_TRANSACTION_INBOXE_AREA,
  claimId,
});

export const setTransactionInboxeAreaClaim = (payload: any) => ({
  type: REQUEST_SET_TRANSACTION_INBOXE_AREA,
  payload,
});

export const requestAddTutorInfo = (
  payload: any,
  successCallBack: Function,
) => ({
  type: REQUEST_ADD_TUTOR_INFO,
  payload,
  successCallBack,
});

export const requestAddBeneficiary = (
  payload: BeneficiaryType,
  successCallBack: Function,
) => ({
  type: REQUEST_ADD_BENEFICIARY,
  payload,
  successCallBack,
});
